
'use strict'

import AreasDetailContact from "./AreasDetailContact";

class AreasDetail{
    constructor(){
        
        this._contact = new AreasDetailContact();
    }
}

export default AreasDetail;